import { DocumentMessage, EmailCreateFormValues } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const postCreateApplicationEmail = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: EmailCreateFormValues,
): Promise<NonPaginatedResponse<DocumentMessage> | undefined> =>
  constructPost(
    `${MIDDLE_OFFICE_BASE_PATH}/${uuid}/messages/email`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
